import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../redux/actions/user.actions";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PeopleIcon from '@mui/icons-material/People';
import './usercard.scss'
import DeleteConfirmationModal from '../../components/Comman/ConfirmationModal';

export default function UserCard(props) {
	const { user, handleUpdate, handleView, loginUser } = props;
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [idDelete,setIdDelete] = useState(null)


	const handleDelete = (userid) => {
		setOpen(true)
		setIdDelete(userid)
	};

	const handleDeleteFunction = () => {
		dispatch(deleteUser(idDelete?.id));
		setOpen(false)
	}
	

	return (
		<div className="col-6 col-sm-4 col-md-3 col-lg-2_4 p-1" key={user.id}>
			<div className="card position-relative shadow-lg border-0 rounded-4 user-card h-100">
				<div className="card-body">
					<div className="d-flex align-items-center mb-3 ">
						<div
							className={`avatar-circle me-3 text-white fw-bold`}
							style={{
								backgroundColor: user?.role === "Admin" ? "rgba(0, 165, 162, 0.9)" : "#727575e6",
								width: "48px",
								height: "48px",
								borderRadius: "50%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: "1.2rem",
							}}
						>
							{user?.name[0]}
						</div>
						<div>
							<h6 className="mb-0 fw-bold">{user?.name}</h6>
							<small className="text-muted d-inline-block text-truncate" style={{ maxWidth: "150px" }}
								title={user?.email}>{user?.email}</small>
						</div>
						<div className="ms-auto position-absolute top-0 end-0 p-2">
							{user?.role === "Admin" ? (
								<AdminPanelSettingsIcon style={{ color: "rgba(0, 165, 162, 0.9)" }} />
							) : (
								<PeopleIcon className="text-warning" />
							)}
						</div>
					</div>

					{loginUser?.role === "Admin" && loginUser !== null && (
						<div className="d-flex justify-content-evenly gap-2 mt-4">
							<button
								className="btn btn-sm btn-outline-info"
								onClick={() => handleView(user?.id)}
							>
								<VisibilityIcon fontSize="small" />
							</button>
							<button
								className="btn btn-sm btn-outline-primary"
								onClick={() => handleUpdate(user?.id)}
							>
								<Edit fontSize="small" />
							</button>
							<button
								className="btn btn-sm btn-outline-danger"
								onClick={() => handleDelete(user)}
							>
								<Delete fontSize="small" />
							</button>
						</div>
					)}
				</div>
			</div>
			<DeleteConfirmationModal
				open={open}
				onClose={() => setOpen(false)}
				onConfirm={handleDeleteFunction}
				title="Delete Confirmation"
				message={` ${idDelete?.name}`}
			/>
		</div>
	);
}
